import React from 'react';
export const ValueContainer = props => /*#__PURE__*/React.createElement("div", {
  className: props.selectProps.classes.valueContainer
}, props.children);